import { getOrderSaleItems } from '@src/domains/orders/core/getOrderSaleItems';
import type { Order } from '@src/domains/orders/types/order';
import { getServiceFeeDescriptions } from '@src/domains/service-fees';

export const getOrderServiceFeeDescriptions = (order: Order | null | undefined): string[] =>
  getServiceFeeDescriptions(order ? getOrderSaleItems(order) : []);
